import m from "../../es2015/lang/pl_PL";
window.am4lang_pl_PL = m;


//////////////////
// WEBPACK FOOTER
// ./lang/pl_PL.js
// module id = null
// module chunks = 